import './bml-home-about.scss';
const TEMPLATE = `
<section class="about-us fade-up">
    <div class="row">
        <div class="col-md-6 col-lg-6">
            <div class="about-circle-container d-none d-lg-block">
                <div class="circle-about-us first-circle"></div>
                <div class="circle-about-us second-circle"></div>
                <div class="circle-about-us third-circle"></div>
            </div>
            <p class="section-label" data-animate-child>
                Про нас
            </p>
        </div>
        <div class="col-md-6 col-lg-6">
            <div class="about-us-text">
                <h2 id="header-about-us" data-animate-child data-delay="200">
                    Цифрова патоморфологія для точних діагнозів та швидких клінічних рішень
                </h2>
                <div class="scientists-image" data-animate-child data-delay="400"></div>
                <p data-animate-child data-delay="600">
                    BML — високотехнологічна лабораторія, що робить ставку на цифрові рішення та міжнародну
                    експертизу. Ми гарантуємо чіткі строки виконання, прозорі процеси та результати, підтверджені
                    світовими стандартами. Завдяки сучасному обладнанню і професіоналізму наших патоморфологів, лікарі отримують
                    надійний фундамент для ухвалення клінічних рішень, а пацієнти — впевненість у правильності
                    діагнозу.
                </p>
                <a href="/about-us" data-animate-child data-delay="800">
                    Дізнатись більше
                </a>
            </div>
        </div>
    </div>
</section>
`;

class BmlHomeAbout extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}

customElements.define('bml-home-about', BmlHomeAbout);
